import {
  Option,
  SelectBox,
  SelectBoxProps,
  styled,
  useTheme,
} from "@monolith-forensics/monolith-ui";
import {
  PRESERVATION_STATUSES,
  PreservationStatus,
} from "../preservations.constants";

export type PreservationStatusSelectBoxProps = Omit<
  SelectBoxProps,
  | "data"
  | "renderOption"
  | "OptionTooltip"
  | "searchable"
  | "loading"
  | "defaultValue"
  | "value"
> & {
  defaultValue?: Option;
  value?: Option;
};

// Tooltip content component
const TooltipContent = styled(
  ({ className, data }: { className?: string; data: PreservationStatus }) => {
    return (
      <div className={className}>
        <div className="detail-title">Preservation Status</div>
        <div className="detail-item">
          <div className="detail-label">Name: </div>
          <div className="detail-value">{data.name || "None"}</div>
        </div>
      </div>
    );
  }
)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: fit-content;
  max-width: 300px;

  .detail-title {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 8px;
  }

  .detail-item {
    display: flex;
    gap: 2px;
  }

  .detail-label {
    font-weight: bold;
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 12px;
  }

  .detail-value {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 12px;
  }
`;

export const PreservationStatusSelectBox: React.FC<PreservationStatusSelectBoxProps> =
  (props) => {
    const records: PreservationStatus[] = PRESERVATION_STATUSES;

    // Combine number and name in label for client-side search by either
    const options: Option[] = records.map((status) => {
      return {
        label: status.name,
        value: status.id,
        data: status,
      };
    });

    return (
      <SelectBox
        placeholder="Select or search for a preservation status..."
        label="Status"
        description="The status of the preservation"
        OptionTooltip={TooltipContent}
        openOnFocus={false}
        {...props}
        data={options}
        searchable={true}
      />
    );
  };
